import datasetTabTemplate from './datasetTabTemplate';

export default datasetTabTemplate(['datasets'], ({ datasets }) => datasets.read);
